import { render, staticRenderFns } from "./DownloadBtn.vue?vue&type=template&id=34ca40fa&"
import script from "./DownloadBtn.vue?vue&type=script&lang=ts&"
export * from "./DownloadBtn.vue?vue&type=script&lang=ts&"
import style0 from "./DownloadBtn.vue?vue&type=style&index=0&id=34ca40fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports